import React from 'react';
import { Zap, Shield, ThumbsUp, Users } from 'lucide-react';

const advantages = [
  {
    icon: Zap,
    title: 'Service rapide',
    description: 'Prise en charge efficace et résultats visibles dès la première visite.',
    color: 'from-cyan-500 to-blue-600',
  },
  {
    icon: Shield,
    title: 'Satisfaction garantie',
    description: 'Nous ne partons pas tant que vous n\'êtes pas 100% satisfait du résultat.',
    color: 'from-blue-500 to-indigo-600',
  },
  {
    icon: ThumbsUp,
    title: 'Estimation gratuite',
    description: 'Obtenez un prix transparent sans aucun engagement de votre part.',
    color: 'from-indigo-500 to-purple-600',
  },
  {
    icon: Users,
    title: 'Équipe professionnelle',
    description: '5 ans d\'expérience, équipements modernes et techniques éprouvées.',
    color: 'from-purple-500 to-pink-500',
  },
];

const WhyChooseUs = () => {
  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="advantages" className="py-8 md:py-12 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-14">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Pourquoi{' '}
            <span className="bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent">
              nous choisir
            </span>
          </h2>
          <p className="text-base md:text-lg text-gray-600">
            Une équipe jeune et minutieuse, dédiée à la qualité de votre service.
          </p>
        </div>

        {/* Advantages Grid - 2x2 on mobile, 4 cols on desktop */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6 max-w-5xl mx-auto mb-8 md:mb-12">
          {advantages.map((adv, i) => {
            const Icon = adv.icon;
            return (
              <div
                key={i}
                className="bg-white rounded-xl md:rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-4 md:p-6 text-center group hover:-translate-y-1"
              >
                <div className={`inline-flex bg-gradient-to-br ${adv.color} rounded-xl p-3 md:p-4 mb-3 md:mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className="text-white" size={22} />
                </div>
                <h3 className="text-sm md:text-lg font-bold text-gray-900 mb-1 md:mb-2">{adv.title}</h3>
                <p className="text-xs md:text-sm text-gray-600 leading-relaxed">{adv.description}</p>
              </div>
            );
          })}
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-3 gap-3 md:gap-6 max-w-3xl mx-auto mb-8 md:mb-12">
          <div className="text-center p-3 md:p-5 bg-white rounded-xl shadow-md">
            <div className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent mb-0.5">500+</div>
            <div className="text-[10px] md:text-sm text-gray-600 font-medium">Clients satisfaits</div>
          </div>
          <div className="text-center p-3 md:p-5 bg-white rounded-xl shadow-md">
            <div className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent mb-0.5">5 ans</div>
            <div className="text-[10px] md:text-sm text-gray-600 font-medium">D'expérience</div>
          </div>
          <div className="text-center p-3 md:p-5 bg-white rounded-xl shadow-md">
            <div className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text text-transparent mb-0.5">100%</div>
            <div className="text-[10px] md:text-sm text-gray-600 font-medium">Satisfaction</div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={scrollToContact}
            className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white px-6 py-3 rounded-full font-semibold text-sm md:text-base shadow-lg hover:shadow-xl transition-all transform hover:scale-105"
          >
            Demander une estimation gratuite
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
